import React, {Fragment, useEffect, useState} from 'react';
import './UserEquipment.css';
import Menu from "../../../Components/Menu/Menu";
import {useNavigate, useSearchParams} from "react-router-dom";
import axios from "axios";

const UserEquipment = () => {

    const [searchParams] = useSearchParams();
    const idFromUrl = searchParams.get('id');

    // const [selectedId, setSelectedId] = useState(null);

    const navigate = useNavigate();
    // const [userBoxes, setUserBoxes] = useState(null);
    const [choosedBox, setChoosedBox] = useState(null);
    const [loaded, setLoaded] = useState(false);

    const [boxesId, setBoxesId] = useState({'1': null, '2': null, '3': null, '4': null, '5': null, '6': null,
                        '7': null, '8': null, '9': null, '10': null, '11': null, '12': null});

    useEffect(() => {
        if (idFromUrl) {
            setChoosedBox(idFromUrl.split('-')[2]);
        }
    }, [idFromUrl, setChoosedBox]);

    // useEffect(() => {
    //     axios.get(`/api/is_shelf/`, {headers: {
    //             'Content-Type': 'application/json',
    //             'Access-Control-Allow-Origin': '*',
    //             // 'X-CSRFToken': getCookie('csrftoken'),
    //             'Access-Control-Allow-Headers': 'X-CSRFToken'
    //         }, withCredentials: true})
    //         .then(res => {
    //             if (res.data.detail) {
    //                 navigate('/user_reserved');
    //             }
    //         })
    //         .catch(e => {
    //             console.log(e);
    //         })
    // }, []);

    useEffect(() => {
        axios.get(`/api/is_shelf/`, {headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                // 'X-CSRFToken': getCookie('csrftoken'),
                'Access-Control-Allow-Headers': 'X-CSRFToken'
            }, withCredentials: true})
            .then(res => {
                if (res.data.detail === true) {
                    console.log(res.data.detail);
                    navigate('/box_reserve/user_reserved');
                } else {
                    axios.get(`/api/shelves/`, {headers: {
                            'Content-Type': 'application/json',
                            'Access-Control-Allow-Origin': '*',
                            // 'X-CSRFToken': getCookie('csrftoken'),
                            'Access-Control-Allow-Headers': 'X-CSRFToken'
                        }, withCredentials: true})
                        .then(res => {
                            if (res.data.detail.length !== 0) {
                                // setUserBoxes(res.data.detail);
                                for (let box of res.data.detail) {
                                    if (box.status === 'occupied' || box.is_blocked) {
                                        document.getElementById('u-box-' + box.name)?.classList.add('u-box-reserved');
                                    }

                                    setBoxesId(prevState => ({ ...prevState, [box.name]: box.id }))
                                }
                            }
                            setLoaded(true);
                        })
                        .catch(e => {
                            console.log(e);
                            setLoaded(true);
                            // if (e.status === 401) {
                            //     navigate('/login');
                            // }
                        })
                }
            })
            .catch(e => {
                console.log(e);
                if (e.status === 401) {
                    navigate('/login');
                }
            })

    }, [setBoxesId, setLoaded]);

    const selectBox = (num) => {
        setChoosedBox(num);
    }

    const goBack = () => {
        if (window.history.length > 1) {
            navigate(-1);
        } else {
            navigate('/box_reserve');
        }
    }

    const openUserBox = () => {
        console.log(boxesId[choosedBox], ' ', choosedBox);
        axios.get(`/api/reserve_shelf/?id=${boxesId[choosedBox]}`, {headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                // 'X-CSRFToken': getCookie('csrftoken'),
                'Access-Control-Allow-Headers': 'X-CSRFToken'
            }, withCredentials: true})
            .then(res => {
                if (res.status === 200) {
                    console.log('Дверь успешно открыта');
                    navigate('/box_reserve/user_reserved');
                }
            })
            .catch(e => {
                console.log(e);
                if (e.status === 401) {
                    navigate('/login');
                }
            })
    }

    return (
        <div className={'user-equipment-container'}>
            <Menu/>
            <div className={`user-equipment-title ${loaded ? '' : 'u-eq-page-not-loaded'}`}>Мой шкаф:</div>

            <div className={`user-equipment-box-container ${loaded ? '' : 'u-eq-page-not-loaded'}`}>
                <div className={'user-equipment-box-row'}>
                    <div id={'u-box-1'} className={`user-equipment-box ${choosedBox === '1' ? 'user-equipment-box-selected' : ''}`} onClick={() => selectBox('1')}>
                        <p className={'user-equipment-box-number'}>1</p>
                    </div>
                    <div id={'u-box-2'} className={`user-equipment-box ${choosedBox === '2' ? 'user-equipment-box-selected' : ''}`} onClick={() => selectBox('2')}>
                        <p className={'user-equipment-box-number'}>2</p>
                    </div>
                    <div id={'u-box-3'} className={`user-equipment-box ${choosedBox === '3' ? 'user-equipment-box-selected' : ''}`} onClick={() => selectBox('3')}>
                        <p className={'user-equipment-box-number'}>3</p>
                    </div>
                </div>

                <div className={'user-equipment-box-row'}>
                    <div id={'u-box-4'} className={`user-equipment-box ${choosedBox === '4' ? 'user-equipment-box-selected' : ''}`} onClick={() => selectBox('4')}>
                        <p className={'user-equipment-box-number'}>4</p>
                    </div>
                    <div id={'u-box-5'} className={`user-equipment-box ${choosedBox === '5' ? 'user-equipment-box-selected' : ''}`} onClick={() => selectBox('5')}>
                        <p className={'user-equipment-box-number'}>5</p>
                    </div>
                    <div id={'u-box-6'} className={`user-equipment-box ${choosedBox === '6' ? 'user-equipment-box-selected' : ''}`} onClick={() => selectBox('6')}>
                        <p className={'user-equipment-box-number'}>6</p>
                    </div>
                </div>

                <div className={'user-equipment-box-row'}>
                    <div id={'u-box-7'} className={`user-equipment-box ${choosedBox === '7' ? 'user-equipment-box-selected' : ''}`} onClick={() => selectBox('7')}>
                        <p className={'user-equipment-box-number'}>7</p>
                    </div>
                    <div id={'u-box-8'} className={`user-equipment-box ${choosedBox === '8' ? 'user-equipment-box-selected' : ''}`} onClick={() => selectBox('8')}>
                        <p className={'user-equipment-box-number'}>8</p>
                    </div>
                    <div id={'u-box-9'} className={`user-equipment-box ${choosedBox === '9' ? 'user-equipment-box-selected' : ''}`} onClick={() => selectBox('9')}>
                        <p className={'user-equipment-box-number'}>9</p>
                    </div>
                </div>

                {/*<div className={'user-equipment-box-row'}>*/}
                {/*    <div id={'u-box-10'} className={`user-equipment-box ${choosedBox === '10' ? 'user-equipment-box-selected' : ''}`} onClick={() => selectBox('10')}>*/}
                {/*        <p className={'user-equipment-box-number'}>10</p>*/}
                {/*    </div>*/}
                {/*    <div id={'u-box-11'} className={`user-equipment-box ${choosedBox === '11' ? 'user-equipment-box-selected' : ''}`} onClick={() => selectBox('11')}>*/}
                {/*        <p className={'user-equipment-box-number'}>11</p>*/}
                {/*    </div>*/}
                {/*    <div id={'u-box-12'} className={`user-equipment-box ${choosedBox === '12' ? 'user-equipment-box-selected' : ''}`} onClick={() => selectBox('12')}>*/}
                {/*        <p className={'user-equipment-box-number'}>12</p>*/}
                {/*    </div>*/}
                {/*</div>*/}
            </div>

            <div className={`user-equipment-button-container ${loaded ? '' : 'u-eq-page-not-loaded'}`}>
                <div className={'user-equipment-button u-eq-btn-opn'} onClick={() => openUserBox()}>Занять шкаф</div>
                <div className={'user-equipment-button u-eq-btn-back'} onClick={() => goBack()}>Назад</div>
            </div>
        </div>
    );
};

export default UserEquipment;